import React from 'react';

const HeatmapView = () => {
  return (
    <iframe
      src="https://iframe.krgsc.kz/heatmap-view"
      title="heatmap-view"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};
export default HeatmapView;
